import { Component, ViewChild } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Headers, RequestOptions } from '@angular/http';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';

import { configData } from './config';

import { enableProdMode } from '@angular/core';
import 'rxjs/add/operator/map'

import * as d3 from "d3";

// Enable production mode unless running locally
if (!/localhost/.test(document.location.host)) {
  enableProdMode();
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  showMessage : any = '';
  showLoader : any = '';
  showSaveForm : any = '';

  viewBox = 256;

  title = 'app';
  jacketImage : any = '<img src="assets/images/jacket-image.jpg" alt="jacket-image"/>';
  selectDesign : string = 'basic';
  config = JSON.parse(JSON.stringify(configData));
  position : string = 'front';
  selectedArea : any = '';

  designPlaces = [];

  pinsActive : boolean = true;

  baseUrl : string = "http://localhost";
  // apiUrl : string = "http://hireswiftdeveloper.com/Seniorjackets/admin/";
  // apiUrl : string = "http://localhost/admin(SeniourJackets)/";
  apiUrl : string = "http://designer.seniorjackets.com/admin/";

  userForm : FormGroup;
  error : any = {}
  EMAIL_REGES : RegExp = /^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4}[\W]*,{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,10})[\W]*$/;

  constructor(private http: HttpClient, public fb: FormBuilder) {

    this.userForm = fb.group({
        email: ['',[Validators.required, Validators.pattern(this.EMAIL_REGES), Validators.maxLength(50)]],
        name: ['', [Validators.required, Validators.maxLength(50)]],

        mobile: ['', [Validators.required, Validators.maxLength(10)]],
        country: ['', [Validators.required, Validators.maxLength(50)]],
        schoolName: ['', [Validators.required, Validators.maxLength(200)]],
        numberOfJackets: ['', [Validators.required, Validators.maxLength(5)]]
      })

      this.userForm.valueChanges.subscribe(data => {
        this.error = {};
      })  

    let designId = window.location.toString().split('?design=')[1];
    if(designId){
      http.get(this.apiUrl+'get-design.php?design='+designId)
      .subscribe((design : any) => {
        if(design && design.status && design.dasignData){
          this.config = JSON.parse(JSON.stringify(design.dasignData));
          this.applyDesignOnJacket();
          this.getDesignComponents();
          this.selectDesignChange(this.selectDesign);
        }else{
          this.getDesignComponents();
        }
      }, data => {
        this.getDesignComponents();
      });
    }else{
      this.getDesignComponents();
    }

  }

  getDesignComponents(){
    this.config.imagePath = this.apiUrl+'UploadFolder/';
    this.http.get(this.apiUrl+'api.php?api=getColors')
    .subscribe((colors : any) => {
      this.config.colorPalette = colors;
    });

    this.http.get(this.apiUrl+'api.php?api=getPatches')
    .subscribe((patchImages : any) => {
      this.config.patchImages = patchImages;
    });

    this.http.get(this.apiUrl+'api.php?api=getArtWorks')
    .subscribe((clipartImages : any) => {
      this.config.clipartImages = clipartImages;
    });
  }

  ngOnInit(): void {
   this.selectDesignChange(this.selectDesign);
  }

  preview : boolean = false;
  togglePreview(){
    this.preview = !this.preview;
  }

  checkDesignNeedsToSaveOrUpdate(){
    let designId = window.location.toString().split('?design=')[1];
    if(designId){
      this.saveDesignFinally({});
    }else{
      this.showSaveForm = true;
    }
  }

  startAgain(con : any = ''){
    if(!con){
      con = confirm('Are you sure you want to start again?')
    }
    if(con){
      console.log('con : ', con)
      window.location.href = window.location.toString().split('?design=')[0];
      this.config = JSON.parse(JSON.stringify(configData));
      this.selectDesignChange(this.selectDesign);
      this.applyDesignOnJacket();
      this.removeAllOutLines();
      window.location.reload();
    }else{
      console.log('con : ', con)      
    }
    
  }

  selectDesignChange(selectDesign, jacketLocation : any = '', index : number = 0){

    console.log('this.config.customisationDefaults.designPlaces : ', this.config.customisationDefaults.designPlaces);
    console.log('selectDesignChange : ', selectDesign);
    console.log('jacketLocation : ', jacketLocation);

    if(jacketLocation){
      this.config.customisationDefaults.designPlaces.forEach((designPlace)=>{
        designPlace.active = false;
      })
      jacketLocation.active = true;
      if(index){
        this.config.customisationDefaults.designPlaces[index].active = true;
      }
      // this.config.customisationDefaults.designPlaces.indexOf(jacketLocation).active = true;
    }
    

    if(selectDesign == 'basic'){
      this.position = 'front';
    }else{
      this.position = selectDesign;
    }

    this.designPlaces = this.config.customisationDefaults[selectDesign];

    setTimeout(()=>{
      if(this.designPlaces && (this.designPlaces.length == 1)){
        this.designPlaces[0].active = true;
        this.showDesignOptions(this.designPlaces[0], this.selectDesign);
      }
    });

    document.body.scrollTop = document.documentElement.scrollTop = 0;
    

    /*
    if(selectDesign == 'back'){
      this.position = 'back';
    }else{
      this.position = 'front';
    }*/
  }

  goNext(currentArea){
    for(let i = 0;i < configData.customisationDefaults.designPlaces.length;i++){
      // if(currentArea == configData.customisationDefaults.designPlaces[i].name){
      if(this.config.customisationDefaults.designPlaces[i].active){
        if(i < configData.customisationDefaults.designPlaces.length-1){
          let nextDesign = (i+1);
          this.selectDesignChange(this.config.customisationDefaults.designPlaces[nextDesign].name, this.config.customisationDefaults.designPlaces[nextDesign], nextDesign);
          this.config.customisationDefaults.designPlaces[i+1].active = true;
        }
        return false;
      }
    }
  }

  selectColor(color){
    this.selectedArea.color = color;
    this.selectedArea = '';
    this.applyDesignOnJacket();
    this.removeAllOutLines();
  }

  removeAllOutLines(){
    this.config.customisationDefaults.helpers.forEach(helper => {
      let target : any = document.getElementsByClassName(helper.target.split('.')[1]);
      Array.prototype.forEach.call(target, element => {
        element.classList.remove("active-path");
      });
    });
  }

  mouseEnter(helper){

    let target : any = document.getElementsByClassName(helper.target.split('.')[1]);
    Array.prototype.forEach.call(target, element => {
      element.classList.add("active-path");
    });
  }
  mouseLeave(helper){
    let target : any = document.getElementsByClassName(helper.target.split('.')[1]);
    Array.prototype.forEach.call(target, element => {
      element.classList.remove("active-path");
    });
  }

  removeActivePath(helper){
    let target : any = document.getElementsByClassName(helper.split('.')[1]);
    Array.prototype.forEach.call(target, element => {
      element.classList.remove("active-path");
    });
  }

  showDesignOptions(anchor, selectDesign){
    this.pinsActive = false;
    this.designPlaces.forEach(element => {
      element.active = false;
    });
    anchor.active = true;

    this.selectedArea = anchor;

    console.log('showDesignOptions : ', anchor, selectDesign);
    this.config.customisationDefaults.helpers.forEach(helper => {
        let target : any = document.getElementsByClassName(helper.target.split('.')[1]);
        Array.prototype.forEach.call(target, element => {
          element.classList.remove("active-path");
        });
    });
    let target : any = document.getElementsByClassName(anchor.selector.split('.')[1]);
    Array.prototype.forEach.call(target, element => {
      element.classList.add("active-path");
    });
  }

  pinClick(helper){
    console.log('pinClick helper : ', helper)
    this.pinsActive = false;
    this.designPlaces.forEach(element => {
      if(helper.target == element.selector){
        this.showDesignOptions(element, '')
      }
    });
  }

  applyDesignOnJacket(){
    this.config.customisationDefaults.basic.forEach(element => {
      let target : any = document.getElementsByClassName(element.selector.split('.')[1]);
      Array.prototype.forEach.call(target, elementSingle => {
        elementSingle.style.fill = element.color;
      });
    });

    this.config.customisationDefaults.left.forEach(element => {
      if(element.selectedStyle.image && element.selectedStyle.image['xlink:href']){
        this.setImageSrc(element);
      }else if(element.selectedStyle.text && element.selectedStyle.text.text){
        this.setTextNode(element)
      }else{
        d3.select(element.selector).selectAll("svg").remove();
      }
    });

    this.config.customisationDefaults.right.forEach(element => {
      if(element.selectedStyle.image && element.selectedStyle.image['xlink:href']){
          this.setImageSrc(element);
      }else if(element.selectedStyle.text && element.selectedStyle.text.text){
        this.setTextNode(element)
      }else{
        d3.select(element.selector).selectAll("svg").remove();
      }
    });

    /*
    this.config.customisationDefaults.inner.forEach(element => {
      element.patchSelector.forEach(selector =>{
        d3.select(element.selector).fill = this.config.customisationDefaults.inner.innerDesignSelectedColor;
      })
      
      
      if(element.selectedStyle && element.selectedStyle.image && element.selectedStyle.image['xlink:href']){
        this.setImageSrc(element);
      }else{
        d3.select(element.selector).selectAll("svg").remove();
      }
    });*/

    this.config.customisationDefaults.front.forEach(element => {
      if(element.selectedStyle.image && element.selectedStyle.image['xlink:href']){
        this.setImageSrc(element);
      }else if(element.selectedStyle.text && element.selectedStyle.text.text){
        this.setTextNode(element)
      }else{
        d3.select(element.selector).selectAll("svg").remove();
      }
    });

    this.config.customisationDefaults.back.forEach(element => {
      if(element.selectedStyle.text){
      // if(element.selectedStyle.text && element.selectedStyle.text.text && element.selectedStyle.text.text.length){
        this.setTextNode(element)
      } else{
        if(element.selectedStyle.image && element.selectedStyle.image['xlink:href']){
          this.setImageSrc(element);
        }else{
          d3.select(element.selector).selectAll("svg").remove();
        }
      }
    });

    if(this.config.customisationDefaults.inner[0].innerColor){
      let target : any = document.getElementsByClassName('inner-jacket-body');
      Array.prototype.forEach.call(target, elementSingle => {
        elementSingle.style.fill = this.config.customisationDefaults.inner[0].innerColor;
      });
    }

  }

  applyTextChnages(){
    this.config.customisationDefaults.back.forEach(element => {
      if(element.selectedStyle.text && element.selectedStyle.text.text && element.selectedStyle.text.text.length){
        this.setTextNode(element)
      }
    });
  }

  setTextNode(data, text : any = '', font : any = ''){
    if(text){
      data.selectedStyle.text.text = text;
    }


    if(data.selectedStyle.image && data.selectedStyle.image['xlink:href']){
      delete data.selectedStyle.image['xlink:href'];
      let elementPre : any = d3.select(data.selector+'-parent');
        elementPre.selectAll("svg").remove();
    }


    if(!font){
      font = JSON.parse(JSON.stringify(data.selectedStyle.text.font));
    }
    console.log("setTextNode : ", data, data.selectedStyle.text.font)
    if(font && font.fontName && font.name){
      data.selectedStyle.text.font = JSON.parse(JSON.stringify(font));
      data.selectedStyle.text.style = 'font-family:'+font.fontName+';direction:'+font.direction; 
    }

    // console.log('data.selector :', data.selector);

    let innerElement : any = d3.select('.in'+data.selector);
    let element : any = d3.select(data.selector+'-parent');
    // console.log('innerElement : ', innerElement);
    // console.log('element : ', element);


    try{
      if(!element || !innerElement || (innerElement && !innerElement.attr('height'))){
        return;
      }
    }catch(e){
      // console.log('catch :', e);
      return;
    }
    
    

    data.selectedStyle.text.height = innerElement.attr('height');
    data.selectedStyle.text.width = innerElement.attr('width');
    element.selectAll("text").remove();

    if(data.selectedStyle.text.fontSize){
      // data.selectedStyle.text.style = 'font-family:'+font.fontName+';direction:'+font.direction; 
      element.attr('font-size', data.selectedStyle.text.fontSize);
    }

    if(data.selectedStyle.text){
        element = element.append("text");
        
        for (var key in data.selectedStyle.text) {
            if (key === 'length' || !data.selectedStyle.text.hasOwnProperty(key))continue;
            if (key === 'text') element.text(data.selectedStyle.text.text);
            
            var value = data.selectedStyle.text[key];
            element.attr(key, data.selectedStyle.text[key]);
        }
    }
  }

  convertInDataUrl(src : string = ''){
    return new Promise((resolve, reject) => {
      let image = document.createElement('img');
      image.src = src;

      image.onload = (e : any) => {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0);
        console.log("canvas.toDataURL() : ", canvas.toDataURL());
        resolve(canvas.toDataURL());
      }
    })
  }

  setImageInSVG(data, imgSrc){
    if(imgSrc.indexOf('data:image/png;base64')){
      this.setImageSrc(data, imgSrc);
    }else{
      this.convertInDataUrl(imgSrc).then(src =>{
        console.log('then');
        this.setImageSrc(data, src);
      }).catch(e => {
        this.setImageSrc(data, imgSrc);
      })
    }
  }

  /*
  setImageSrc(data, imgSrc : any = ''){
    if(imgSrc){
      data.selectedStyle.image['xlink:href'] = imgSrc;
    }
    console.log('data : ', data)
    let element : any = d3.select(data.selector);
    element.selectAll("svg").remove();
    
    if(data.selectedStyle.svg){
        element = element.append("svg");
        
        for (var key in data.selectedStyle.svg) {
            if (key === 'length' || !data.selectedStyle.svg.hasOwnProperty(key))continue;
            
            var value = data.selectedStyle.svg[key];
            element.attr(key, data.selectedStyle.svg[key]);
        }
    }
    
    if(data.selectedStyle.image){
        element = element.append("image");
        for (var key in data.selectedStyle.image) {
            if (key === 'length' || !data.selectedStyle.image.hasOwnProperty(key)) continue;

            var value = data.selectedStyle.image[key];
            element.attr(key, data.selectedStyle.image[key]);
        }
    }
  }*/
  setImageSvg(data, imgSrc : any = ''){
    if(imgSrc){
      data.selectedStyle.image['xlink:href'] = imgSrc;
    }
    
    let innerElement : any = d3.select(data.selector+'.in');
    let element : any = d3.select(data.selector+'-parent');

    try{
      if(!element || !innerElement.attr('height')){
        return;
      }
    }catch(e){
      // console.log('catch :', e);
      return;
    }
    
    element.selectAll("svg").remove();
    
    if(data.selectedStyle.svg){
      
        element = element.append("svg");

        element.attr('height', innerElement.attr('height'));
        element.attr('width', innerElement.attr('width'));
        element.attr('x', innerElement.attr('x'));
        element.attr('y', innerElement.attr('y'));
        element.attr('viewBox', "0 0 256 256");
    }
    
    if(data.selectedStyle.image){
        element = element.append("image");
        for (var key in data.selectedStyle.image) {
            if (key === 'length' || !data.selectedStyle.image.hasOwnProperty(key)) continue;

            var value = data.selectedStyle.image[key];
            element.attr(key, data.selectedStyle.image[key]);
        }
    }
  }

  setImageSrc(data, imgSrc : any = '', styleChnage : boolean = false){
    let self = this;
    if(imgSrc){
      data.selectedStyle.image['xlink:href'] = imgSrc;
    }

     if(data.selectedStyle.text && data.selectedStyle.text.text){
        data.selectedStyle.text.text = '';

        let elementPre : any = d3.select(data.selector+'-parent');
        elementPre.selectAll("text").remove();
      }

    if(data.selectedStyle.image['xlink:href'].indexOf('.svg') > -1){
      d3.xml(data.selectedStyle.image['xlink:href'], function (xmlData) {
        let svgNode = xmlData.getElementsByTagName("svg")[0];
        svgNode.classList.add('jacketAddedSVG_'+self.position);

        // let svgNode = document.createElement('svg').appendChild(document.createElement('g').appendChild(xmlData.getElementsByTagName("svg")[0]))

        let element : any = d3.select(data.selector+'-parent');
        if(!styleChnage){
          element.selectAll("svg").remove();
        }
        let innerElement : any = d3.select(data.selector+'.in');
        
        try{

          if(!data.selectedStyle.image.x || !data.selectedStyle.image.y){
            data.selectedStyle.image.x = innerElement.attr('x');
            data.selectedStyle.image.y = innerElement.attr('y');
          }

          if(!data.selectedStyle.image.zoom){
            data.selectedStyle.image.zoom = 1;
          }
          

          d3.select(svgNode)
          .attr('height', innerElement.attr('height'))
          .attr('width', innerElement.attr('width'))
          .attr('x', data.selectedStyle.image.x)
          .attr('y', data.selectedStyle.image.y)
          // .attr('class', 'jacketAddedSVG_'+self.position)
          ;

          let svgElement = svgNode.getElementsByTagName("g");

          // let target : any = document.getElementsByClassName(helper.target.split('.')[1]);
          
          Array.prototype.forEach.call(svgElement, svgElementSingle => {
            console.log('svgElementSingle.parentElement.nodeName : ', svgElementSingle.parentElement.nodeName);
            if(svgElementSingle.parentElement.nodeName == 'svg'){
              svgElementSingle.classList.add('addedArtWork');
              svgElementSingle.classList.add('addedArtWork_'+self.position);
            }
          });

          /*
          for(let i = 0;i < svgElement.length;i++){
            d3.select(svgElement[i])
            .attr('class', 'addedArtWork addedArtWork_'+self.position)
          }*/

          // svgNode.getElementsByTagName("g").forEach((element)=>{
          //   element.attr('class', 'addedArtWork addedArtWork_'+self.position)
          // })

          // d3.select(svgNode.getElementsByTagName("g")[0])
          // .attr('class', 'addedArtWork addedArtWork_'+self.position)


          // .attr('style', 'transform:scale('+data.selectedStyle.image.zoom +');opacity: 1;transform-origin: center center !important;');
          
          // setTimeout(()=>{
            // d3.attr('style', 'transform:scale(2);opacity: 1;transform-origin: center center !important;')
          //   d3.attr('style', 'transform:scale(2);')
          // }, 100)
          
        }catch(e){
          console.log("e : ", e)
          return;
        }

        if(!styleChnage){
          element.node().appendChild(svgNode);
        }

        
         setTimeout(()=>{

          element.select('.jacketAddedSVG_'+self.position)
          .attr('x', data.selectedStyle.image.x)
          .attr('y', data.selectedStyle.image.y)

           let z = parseFloat(data.selectedStyle.image.zoom).toFixed(2);
          //  console.log("element.select('.addedArtWork_'+self.position) : ", element.select('.addedArtWork_'+self.position))
          //   element.select('.addedArtWork_'+self.position).attr('style', 'transform:scale('+ z +');opacity: 1;transform-origin: center center;')

          let gElement = element.node().getElementsByClassName('addedArtWork_'+self.position);
          for(let i = 0;i < gElement.length;i++){
            d3.select(gElement[i])
            .attr('style', 'transform:scale('+ z +');opacity: 1;transform-origin: center center;')
          }

          }, 10)
        //  setTimeout(()=>{
        //    element.select('.addedArtWork_'+self.position).attr('style', 'transform:scale('+data.selectedStyle.image.zoom +');opacity: 1;transform-origin: center center;')
        //  }, 50)

        if(data.selectedStyle.image.artworkColor){
          if(data.selectedStyle.image.artworkColor.outerBorder){
            element.selectAll('.badge__color__1').attr('fill', data.selectedStyle.image.artworkColor.outerBorder);
          }
          if(data.selectedStyle.image.artworkColor.innerBorder){
            element.selectAll('.badge__color__2').attr('fill', data.selectedStyle.image.artworkColor.innerBorder);
          }
          if(data.selectedStyle.image.artworkColor.bg){
            element.selectAll('.badge__color__3').attr('fill', data.selectedStyle.image.artworkColor.bg);
          }
        }

      });
      
      return false;
    }


    let innerElement : any = d3.select(data.selector+'.in');
    let element : any = d3.select(data.selector+'-parent');

    try{
      if(!element || !innerElement.attr('height')){
        return;
      }
    }catch(e){
      // console.log('catch :', e);
      return;
    }
    
    element.selectAll("svg").remove();
    
    if(data.selectedStyle.svg){
        element = element.append("svg");

        element.attr('height', innerElement.attr('height'));
        element.attr('width', innerElement.attr('width'));
        element.attr('x', innerElement.attr('x'));
        element.attr('y', innerElement.attr('y'));
        element.attr('viewBox', "0 0 256 256");
        // element.select(element.getElementsByTagName("g")[0])
          // .attr('style', 'transform:scale('+ parseFloat(data.selectedStyle.image.zoom).toFixed(2) +');opacity: 1;transform-origin: center center;')
    }
    
    if(data.selectedStyle.image){
        element = element.append("image");
        for (var key in data.selectedStyle.image) {
            if (key === 'length' || !data.selectedStyle.image.hasOwnProperty(key)) continue;

            var value = data.selectedStyle.image[key];
            element.attr(key, data.selectedStyle.image[key]);
        }
    }
  }


  fileChangeListener($event, data) {
    console.log('fileChangeListener : ', $event)
    if($event && $event.target && $event.target.files && $event.target.files.length){
      var reader = new FileReader();
        
      reader.onload = (e : any) => {
        this.setImageSrc(data, e.target.result);
      }
      reader.readAsDataURL($event.target.files[0]);
    }
  }

  saveDesign(form){

    console.log('form : ', form.value)

    if(form && form.value){
      if(form.value.name){
        if(form.value.email){
          if(this.EMAIL_REGES.test(form.value.email)){
            if(form.value.mobile){
              if(form.value.country){
                if(form.value.schoolName){
                  if(form.value.numberOfJackets){
                    if(form.value.numberOfJackets >= 8){
                      this.showSaveForm = '';
                      this.saveDesignFinally(form.value);
                    }else{
                      // alert('You  need to order minimum 8 jackets');
                      this.error = {
                        type : 'numberOfJackets',
                        text : 'You need to order minimum 8 jackets'
                      }
                    }
                  }else{
                    // alert('Please enter number of jackets');
                    this.error = {
                      type : 'numberOfJackets',
                      text : 'Please enter number of jackets'
                    }
                  }
                }else{
                  // alert('Please enter your school name');
                  this.error = {
                    type : 'schoolName',
                    text : 'Please enter your school name'
                  }
                }
              }else{
                // alert('Please enter your country');
                this.error = {
                  type : 'country',
                  text : 'Please enter your country'
                }
              }
            }else{
              //  alert('Please enter your mobile number');
              this.error = {
                type : 'mobile',
                text : 'Please enter your mobile number'
              }
            }
            // this.showSaveForm = '';
            // this.saveDesignFinally(form.value);
          }else{
            // alert('Please enter vaild email address');
            this.error = {
              type : 'email',
              text : 'Please enter vaild email address'
            }
          }
        }else{
          // alert('Please enter your email address');
          this.error = {
            type : 'email',
            text : 'Please enter your email address'
          }
        }
      }else{
        // alert('Please enter your name');
        this.error = {
          type : 'name',
          text : 'Please enter your name'
        }
      }

      
    }else{
      // alert('Please the your details');
      this.error = {
        type : 'form',
        text : 'Please fill your details'
      }
    }
  }

  saveDesignFinally(userData){
    this.showLoader = 'Saving Design...';
    this.http.post(this.apiUrl+'save.php', 
    {
      designData : this.config, 
      userName : userData.name, 
      userEmail : userData.email,

      userMobile : userData.mobile,
      userCountry : userData.country,
      schoolName : userData.schoolName,
      numberOfJackets : userData.numberOfJackets,
      designId : window.location.toString().split('?design=')[1],

      url : window.location.href.toString().split('?design=')[0]})
      // .map((res : any) => res.json())
      .subscribe((response : any) => {
        this.showLoader = '';
        if(response.status){
          this.showMessage = {message : response.message, btnText : 'Start Again'};
        }else{
          this.showMessage = {message : response.message, btnText : 'Close'};
        }
      }, data => {
        this.showLoader = '';
      });
  }
  
}



// WEBPACK FOOTER //
// /Users/jaswantdhayal/Desktop/Projects/seniorJackets/src/app/app.component.ts